import { useEffect, useRef } from "react";
import "./ArticleAds.css";

const ArticleAds = () => {
  const adRef = useRef(null);

  useEffect(() => {
    try {
      if (adRef.current && adRef.current.childElementCount === 0) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (err) {
      console.error("AdSense Error:", err);
    }
  }, []);

  return (
    <div className="article-ads-container">
      <ins
        ref={adRef}
        className="adsbygoogle"
        style={{ display: "block", textAlign: "center" }}
        data-ad-layout="in-article"
        data-ad-format="fluid"
        data-ad-client="ca-pub-5162535306990850"
        data-ad-slot="2324830876"
      />
    </div>
  );
};

export default ArticleAds;